    import { Component } from '@angular/core';
    import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
    import { FileUploadModule } from '@iplab/ngx-file-upload';
    import { catchError, finalize, of, Subject, takeUntil } from 'rxjs';
    import { ObjectUtility } from '../../utilities/ObjectUtility';
    import { PngIdentityUser } from '../../models/domain/pngIdentityUser';
    import { Router, RouterModule } from '@angular/router';
    import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
    import { AuthenticationService } from '../../services/authentication.service';
    import { ToastrService } from 'ngx-toastr';
    import { LoadingService } from '../../services/loading.service';
    import { whitespaceValidator } from '../../validators/ValidationService';
    import { CommonModule } from '@angular/common';

    @Component({
        selector: 'app-account-settings',
        imports: [FileUploadModule, RouterModule, ReactiveFormsModule, CommonModule],
        templateUrl: './account-settings.component.html',
        styleUrl: './account-settings.component.scss'
    })
    export class AccountSettingsComponent {

        public multiple: boolean = false;
        isToggled = false;

        frmGroup!: FormGroup;
        isSubmitted = false;
        destroy$: Subject<boolean> = new Subject<boolean>();
        user = new PngIdentityUser();

        constructor(public router: Router,
            private formBuilder: FormBuilder,
            public themeService: CustomizerSettingsService,
            public authService: AuthenticationService,
            private toasterService: ToastrService,
            private loadingService: LoadingService,

        ) {
            this.initialize();
        }

        public ngOnInit(): void {
            if (this.authService.isUserAuthenticated()) {
                this.user = ObjectUtility.deepClone(this.authService.getCurrentUser());
                this.setForm(this.user);
            }
        }

        public ngAfterViewInit(): void {

            this.frmGroup.controls['firstNameControl'].valueChanges.subscribe(value => {
                this.user.firstName = value;
            });

            this.frmGroup.controls['lastNameControl'].valueChanges.subscribe(value => {
                this.user.lastName = value;
            });

            this.frmGroup.controls['emailControl'].valueChanges.subscribe(value => {
                this.user.email = value;
            });

            this.frmGroup.controls['phoneNumberControl'].valueChanges.subscribe(value => {
                this.user.phoneNumber = value;
            });
        }

        public ngOnDestroy(): void {
            this.destroy$.next(true);
            this.destroy$.unsubscribe();
        }

        private initialize(): void {
            this.themeService.isToggled$.subscribe(isToggled => {
                this.isToggled = isToggled;
            });
            this.isSubmitted = false;
            this.user = new PngIdentityUser();

            this.createForm();
        }

        private createForm(): void {
            this.frmGroup = this.formBuilder.group({
                firstNameControl: new FormControl('', [Validators.required, whitespaceValidator()]),
                lastNameControl: new FormControl('', [Validators.required, whitespaceValidator()]),
                emailControl: new FormControl('', [Validators.required, whitespaceValidator()]),
                phoneNumberControl: new FormControl('', [Validators.required, whitespaceValidator()])
            })
        }

        get f() { return this.frmGroup.controls; }

        private setForm(user: PngIdentityUser | null): void {
            if (user) {
                this.frmGroup.patchValue({
                    firstNameControl: user.firstName,
                    lastNameControl: user.lastName,
                    emailControl: user.email,
                    phoneNumberControl: user.phoneNumber,
                });
            }
        }

        public toggleClass(): void {
            this.router.navigate(["/dashboard"]);
        }

        public formIsValid(): boolean {
            const isValid = this.frmGroup.controls['firstNameControl'].valid &&
                this.frmGroup.controls['lastNameControl'].valid &&
                this.frmGroup.controls['emailControl'].valid &&
                this.frmGroup.controls['phoneNumberControl'].valid
            return isValid;
        }

        public onSave(): void {
            if (this.frmGroup.valid) {
                this.loadingService.showLoading();
                this.authService.updateProfile(this.user)
                    .pipe(
                        catchError((err: any) => {
                            if (err && err.error) {
                                this.isSubmitted = false;
                                if (err.error.isCustom) {
                                    this.toasterService.warning(err.error.message);
                                } else {
                                    this.toasterService.error('Something went wrong!');
                                }
                            } else {
                                this.isSubmitted = false;
                                this.toasterService.error('Something went wrong!');
                            }
                            this.loadingService.hideLoading();

                            return of(null);
                        }),
                        finalize(() => {
                            this.loadingService.hideLoading();
                        }),
                        takeUntil(this.destroy$))
                    .subscribe(response => {
                        if (response) {
                            this.isSubmitted = false;
                            this.user = response?.body != null ? response?.body : new PngIdentityUser;
                            //this.toggleClass();
                            this.toasterService.success("Save successfully");
                            this.authService.logout();
                        }
                        this.loadingService.hideLoading();
                    });

            }
        }
    }